export default __webpack_public_path__ + "static/media/Shubang.8ad4b762.jpg";